import { render, staticRenderFns } from "./WaterQualityReportsErrorModal.vue?vue&type=template&id=89a37efe&scoped=true"
import script from "./WaterQualityReportsErrorModal.vue?vue&type=script&lang=js"
export * from "./WaterQualityReportsErrorModal.vue?vue&type=script&lang=js"
import style0 from "./WaterQualityReportsErrorModal.vue?vue&type=style&index=0&id=89a37efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a37efe",
  null
  
)

export default component.exports